import "./custom/global.js"; // Make sure this is imported first

import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

import "./custom/address-search.js";
import "./custom/analytics.js";
import "./custom/article-reading.js";
import "./custom/basis-of-faith.js";
import "./custom/cards.js";
import "./custom/church-search.js";
import "./custom/countdown.js";
import "./custom/dynamics.js";
import "./custom/footer.js";
import "./custom/form-church-renew.js";
import "./custom/form-join-us.js";
import "./custom/form-membership-cards.js";
import "./custom/form.js";
import "./custom/gc-search.js";
import "./custom/header.js";
import "./custom/history.js";
import "./custom/home.js";
import "./custom/jobs.js";
import "./custom/login.js";
import "./custom/page.js";
import "./custom/search.js";
import "./custom/sidebar.js";
import "./custom/stay-in-the-loop.js";
import "./custom/swiper.js";
import "./custom/table-of-contents.js";
import "./custom/team.js";
import "./custom/update-account-details.js";
import "./custom/update-meeting-address.js";
import "./custom/video.js";
import "./custom/plyr-video.js";